import { render, staticRenderFns } from "./ComposerAttachment.vue?vue&type=template&id=589c91c2&scoped=true"
import script from "./ComposerAttachment.vue?vue&type=script&lang=js"
export * from "./ComposerAttachment.vue?vue&type=script&lang=js"
import style0 from "./ComposerAttachment.vue?vue&type=style&index=0&id=589c91c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589c91c2",
  null
  
)

export default component.exports